import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { PHONE_DISPLAY, WHATSAPP_URL } from "@/lib/constants";
import { useLanguage } from "@/lib/i18n";
import WhatsAppIcon from "@/components/WhatsAppIcon";

const EASE = [0.22, 1, 0.36, 1];

export default function BookingCta() {
  const { t } = useLanguage();

  return (
    <section id="contatti" data-testid="booking-section" className="py-20 lg:py-28">
      <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="relative overflow-hidden rounded-[2rem] bg-sand border border-[#E2DCD5] px-6 py-14 sm:px-12 sm:py-20 text-center"
        >
          <svg
            aria-hidden="true"
            viewBox="0 0 64 64"
            className="absolute -top-6 -left-6 w-40 h-40 text-terracotta/10 rotate-12"
          >
            <path d="M8 44 L32 18 L56 44" fill="none" stroke="currentColor" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <svg
            aria-hidden="true"
            viewBox="0 0 64 64"
            className="absolute -bottom-8 -right-8 w-48 h-48 text-cypress/10 -rotate-12"
          >
            <path d="M8 44 L32 18 L56 44" fill="none" stroke="currentColor" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>

          <p className="relative font-mono-label text-[11px] uppercase tracking-[0.3em] text-terracotta font-bold mb-4">
            {t.booking.overline}
          </p>
          <h2 className="relative font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-ink text-balance max-w-2xl mx-auto">
            {t.booking.titleA} <em className="text-terracotta">{t.booking.titleEm}</em>
          </h2>
          <p className="relative mt-5 max-w-xl mx-auto text-sm sm:text-base text-clay leading-relaxed">
            {t.booking.body}
          </p>

          <div className="relative mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              data-testid="booking-whatsapp-btn"
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 rounded-full bg-whatsapp px-8 py-4 text-base font-semibold text-white transition-all duration-300 hover:brightness-95 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-whatsapp/30"
            >
              <WhatsAppIcon className="w-5 h-5" />
              {t.booking.whatsapp}
            </a>
            <a
              data-testid="booking-phone-link"
              href={`tel:${PHONE_DISPLAY.replace(/\s/g, "")}`}
              className="inline-flex items-center gap-2.5 rounded-full border border-ink/15 px-8 py-4 text-base font-semibold text-ink transition-all duration-300 hover:border-terracotta hover:text-terracotta"
            >
              <Phone className="w-4 h-4" />
              {PHONE_DISPLAY}
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
